import { theme } from 'aimo-ui';
import React from 'react';
import { StyleSheet, View } from 'react-native';

interface IllustrationContainerProps {
  children: React.ReactNode;
  backgroundColor?: string;
  padding?: number;
  testID?: string;
}

export const IllustrationContainer: React.FC<IllustrationContainerProps> = ({
  children,
  backgroundColor = theme.colors.lightBg.green,
  padding,
  testID,
}) => {
  return (
    <View
      style={[
        styles.container,
        { backgroundColor },
        padding !== undefined && { padding },
      ]}
      testID={testID}>
      {children}
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    borderRadius: 12,
    paddingHorizontal: 20,
    marginVertical: 20,
    alignItems: 'center',
    justifyContent: 'center',
  },
});

export default IllustrationContainer;
